module.exports = __webpack_public_path__ + "img/delete.0159ae8b.svg";